import React, { useEffect, useState } from "react";

import "slick-carousel/slick/slick.css";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick-theme.css";
import Carousel from "shared/components/Carousel";

import TabItem from "./TabItem";
import "./styles.scss";

const TabBar = ({ items, selectedItemIndex }) => {
  const [selectedItem, setSelectedItem] = useState(selectedItemIndex || 0);

  useEffect(() => {
    selectedItemIndex !== selectedItem && setSelectedItem(selectedItemIndex);
  }, [selectedItemIndex]);

  return (
    <Carousel>
      {items.map(({ text, icon, link }, i) => (
        <TabItem
          key={`tabbar:${text}`}
          text={text}
          icon={icon}
          link={link}
          selected={i === selectedItem}
          onClick={() => setSelectedItem(i)}
        />
      ))}
    </Carousel>
  );
};

TabBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      icon: PropTypes.node,
    }),
  ),
  selectedItemIndex: PropTypes.number,
};

TabBar.defaultProps = {};
export default TabBar;
